/** CallPass API 응답 래퍼 — Res<T>: result는 boolean(성공여부), data가 실제 페이로드 */
export interface CallPassApiResponse<T> {
  code: number;
  message: string;
  result: boolean;
  data: T;
}

export interface CallPassAPIInfoDto {
  callCenterType: string;
  apiInfo: string;
  isDeleted: boolean;
}

export interface ReqGetCallPassAPIInfos {
  CompanyGuid: string;
}

export interface ReqUpsertCallPassAPIInfo {
  CallCenterType: string;
  /** 설정 대상 배차 업체 GUID (암호화/저장 기준) */
  CompanyGuid: string;
  /** 설정을 수행하는 로그인 사용자 GUID */
  AuthUserGuid: string;
  APIInfo: string;
  IsDeleted: boolean;
}

export interface Cargo24Auth {
  Key: string;
  AESKey: string;
  AESIV: string;
}

export interface OneCallAuth {
  Key?: string;
  Id?: string;
  Password?: string;
}

export interface InsungAuth {
  MCode: string;
  CcCode: string;
  UserId: string;
  UKey: string;
  AKey: string;
}

/** 24시_AGENT(Agent24 데스크톱 연동)는 별도 인증 정보 없이 { Key: "empty" } 형태로 저장 */
export interface Cargo24AgentAuth {
  Key: string;
}

/**
 * 화물맨(logishm) 인증 정보 — 업체별로 다른 화주 정보만 저장한다.
 *
 * COMCODE·Key·VariablePath는 서버 단위 고정값이라 백엔드 appsettings(Env:CargoMan)에서 관리한다.
 */
export interface CargoManAuth {
  /** 화주 아이디(빽통 회원사 계정) — 테스트/운영 서버가 별도 발급 */
  OwId: string;
  /** 화주명(개인이름 또는 업체명) */
  OwName: string;
}

export type CallCenterType =
  | "24시"
  | "24시_AGENT"
  | "원콜"
  | "인성"
  | "화물맨";

export const CALL_CENTER_TYPES: { value: CallCenterType; label: string }[] = [
  { value: "24시", label: "24시 (Cargo24)" },
  { value: "24시_AGENT", label: "24시 AGENT (Agent24)" },
  { value: "원콜", label: "원콜 (OneCall)" },
  { value: "인성", label: "인성 (Insung)" },
  { value: "화물맨", label: "화물맨 (LogisHM)" },
];

export const CALL_CENTER_STATUS_MAP: Record<
  string,
  { label: string; color: string }
> = {
  active: { label: "사용", color: "bg-green-100 text-green-700" },
  deleted: { label: "미사용", color: "bg-gray-100 text-gray-500" },
  none: { label: "미등록", color: "bg-yellow-100 text-yellow-700" },
};
